import site from '../../site';
import siteLocales from '../../site-locales';
import blocks from '../../blocks';
import verifiers from '../verifiers';
import loadGlobalsFromHTML from '../helpers/load-globals-from-html';
import loadGlobals from '../helpers/load-globals';
import setGlobalHTML from '../actions/set-global-html';
import getGlobals from '../selectors/globals';
import errors from '../../errors';
import constants from '../constants';

const { NAVIGATION_GLOBAL_ID } = constants.navigation;

const globalLoader = (store) => (next) => (action) => {
  switch (action.type) {
    case site.actionTypes.SET_ACTIVE_PAGE: {
      const state = store.getState();
      const { pageId: nextActivePageId } = action.payload;
      const currentActivePageId = site.selectors.getActivePageId(state);
      const currentActivePage = site.selectors.getPage(state, currentActivePageId);
      const nextActivePage = site.selectors.getPage(state, nextActivePageId);
      const { hasGlobals, html } = nextActivePage;

      if (currentActivePage && currentActivePage.locale !== nextActivePage.locale) {
        store.dispatch(siteLocales.actions.clearGlobalsHtml());
      }

      if (!hasGlobals) {
        next(action);
        return;
      }
      loadGlobalsFromHTML(html, nextActivePage.locale)
        .then(() => {
          next(action);
        })
        .catch((error) => {
          errors.operations.catchError(error);
        });
      break;
    }

    case blocks.actionTypes.SET_BLOCK_HTML:
    case blocks.actionTypes.SET_BLOCK_VARIATION_HTML: {
      const { html, locale } = action.payload;
      if (verifiers.hasGlobals(html)) {
        loadGlobalsFromHTML(html, locale)
          .then(() => {
            next(action);
          })
          .catch((error) => {
            errors.operations.catchError(error);
          });

        return;
      }

      next(action);
      break;
    }

    case site.actionTypes.RELOAD_SITE_META:
    case site.actionTypes.CONNECT_SITE: {
      const {
        site: { meta: siteMeta },
      } = action.payload;
      const state = store.getState();
      const activePage =
        siteMeta.pages.find((page) => page.id === siteMeta.activePage) || siteMeta.pages[0];
      const activePageLocale = activePage && activePage.locale;

      const globals = getGlobals(state);

      loadGlobals(
        globals,
        (global, data) => {
          store.dispatch(setGlobalHTML(global.id, data));
          return loadGlobalsFromHTML(data, activePageLocale);
        },
        activePageLocale
      )
        .then(() => {
          next(action);

          if (action.payload.resolve) {
            action.payload.resolve();
          }
        })
        .catch((error) => {
          errors.operations.catchError(error);
        });
      break;
    }

    case siteLocales.actionTypes.ADD_LOCALE: {
      const { isMultilingualSite } = action.payload;

      // If user add his first language, and become multilingual,
      // we would update his pages path, that's why we need to load updated NAVIGATION global content

      if (!isMultilingualSite) {
        const state = store.getState();
        const currentLocale = siteLocales.selectors.getCurrentLocale(state);
        const navGlobal = getGlobals(state).filter((global) => global.id === NAVIGATION_GLOBAL_ID);

        loadGlobals(
          navGlobal,
          (global, data) => {
            store.dispatch(setGlobalHTML(global.id, data));
            return loadGlobalsFromHTML(data, currentLocale);
          },
          currentLocale
        )
          .then(() => {
            next(action);
          })
          .catch((error) => {
            errors.operations.catchError(error);
          });
      }
      break;
    }

    default:
      next(action);
  }
};

export default globalLoader;
